export default "__VITE_ASSET__NUUMKcQT__"